import './App.css'
import Nav from './components/Nav'
import Home from './components/Home'
import Country from './components/Country'
import Practice from './components/Practice'
import Region from './components/Region'
import Historical from './components/Historical'
import PageNotFound from './components/404Page'
import { Routes, Route } from 'react-router-dom'
import React, { useState } from 'react'
import {
    BANNER_SURVEY_NAME_SHORT_NO_CULPEPPER,
    BREAKPOINT_SM,
    CONTACT_US_LINK,
    COOKIE_NOTICE_LINK,
    CURRENT_YEAR,
    CULPEPPER_COME_LINK,
    DATA_CONFIDENTIALITY_LINK,
    PRELIM_SURVEY_LIST,
    PRIVACY_POLICY_LINK,
    SBS_DEV_PAGE_ADDRESS,
    SBS_LOCAL_DEV_PAGE_ADDRESS,
    SURVEY_PUBLISH_DATE_LIST,
    SURVEY_UUID_LIST,
    SURVEY_YEAR_NAME_LIST,
    SBS_PROD_PAGE_ADDRESS,
    DISABLED_ON_PROD_PRELIM_SURVEY_LIST,
    SURVEY_REDIRECT_LINK_LIST,
    PRELIM_SURVEY_LIST_WITH_PUBLISH_DATE,
    PRELIM_SURVEY_LIST_WITH_EFFECTIVE_DATE,
} from './constants/constants'
import { REACT_APP_PAGE_ADDRESS } from './config'
import SurveyHome from './components/SurveyHome'
import { useLocation } from 'react-router-dom'
import Participants from './components/Participants'
import Definitions from './components/Definitions'

function App() {
    const [pathFullName, setPathFullName] = useState(window.location.pathname)
    const location = useLocation()

    React.useEffect(() => {
        setPathFullName(location.pathname)
    }, [location])

    const useViewport = () => {
        const [width, setWidth] = React.useState(window.innerWidth)

        React.useEffect(() => {
            const handleWindowResize = () => setWidth(window.innerWidth)
            window.addEventListener('resize', handleWindowResize)
            return () =>
                window.removeEventListener('resize', handleWindowResize)
        }, [])

        return { width }
    }

    const { width } = useViewport()

    const pathNameFirstPortion = pathFullName.split('/')[1]

    const survey = SURVEY_UUID_LIST[pathNameFirstPortion]
    const surveyYearName = SURVEY_YEAR_NAME_LIST[survey]

    let isPrelimPublishEffective = PRELIM_SURVEY_LIST.includes(survey)
        ? `(Preliminary Results${
              PRELIM_SURVEY_LIST_WITH_PUBLISH_DATE.includes(survey)
                  ? ', '
                  : ' effective '
          }${SURVEY_PUBLISH_DATE_LIST[survey]})`
        : ''

    // Define the RedirectToExternalPage component
    const RedirectToExternalPage = () => {
        React.useEffect(() => {
            window.location.href = SURVEY_REDIRECT_LINK_LIST[survey]
        }, [])

        return null // This component does not render anything
    }

    const isDev = [SBS_LOCAL_DEV_PAGE_ADDRESS, SBS_DEV_PAGE_ADDRESS]
        .map((addr) => addr.replace(/\/$/, ''))
        .includes(REACT_APP_PAGE_ADDRESS.replace(/\/$/, ''))

    const isProd =
        REACT_APP_PAGE_ADDRESS.replace(/\/$/, '') ===
        SBS_PROD_PAGE_ADDRESS.replace(/\/$/, '')

    const isPrelim = PRELIM_SURVEY_LIST.includes(survey)
    const isPrelimWithEffectiveDate =
        PRELIM_SURVEY_LIST_WITH_EFFECTIVE_DATE.includes(survey)
    const isDisabled = DISABLED_ON_PROD_PRELIM_SURVEY_LIST.includes(survey)

    return (
        <div className="App">
            <div className="content-wrap">
                {pathFullName !== '/' && <Nav />}

                <div className="banner printHidden">
                    {surveyYearName} {BANNER_SURVEY_NAME_SHORT_NO_CULPEPPER}{' '}
                    {width < BREAKPOINT_SM ? <br></br> : <span></span>}
                    <em>{isPrelimPublishEffective}</em>
                </div>

                <Routes>
                    {/* Main route */}
                    <Route
                        path="/"
                        element={isDev ? <SurveyHome /> : <SiteRedirect />}
                    />

                    {/* Prelim surveys */}
                    {isPrelim ? (
                        isDev ? (
                            <>
                                <Route path="/:survey" element={<Home />} />
                                <Route
                                    path="/:survey/region"
                                    element={<Region />}
                                />
                                {isPrelimWithEffectiveDate && (
                                    <>
                                        <Route
                                            path="/:survey/country"
                                            element={<Country />}
                                        />
                                        <Route
                                            path="/:survey/practice"
                                            element={<Practice />}
                                        />
                                        <Route
                                            path="/:survey/historical"
                                            element={<Historical />}
                                        />
                                    </>
                                )}
                            </>
                        ) : isProd && isDisabled ? (
                            <>
                                <Route
                                    path="/:survey"
                                    element={<RedirectToExternalPage />}
                                />
                                <Route
                                    path="/:survey/region"
                                    element={<RedirectToExternalPage />}
                                />
                                {isPrelimWithEffectiveDate && (
                                    <>
                                        <Route
                                            path="/:survey/country"
                                            element={<RedirectToExternalPage />}
                                        />
                                        <Route
                                            path="/:survey/practice"
                                            element={<RedirectToExternalPage />}
                                        />
                                        <Route
                                            path="/:survey/historical"
                                            element={<RedirectToExternalPage />}
                                        />
                                    </>
                                )}
                            </>
                        ) : isProd && !isDisabled ? (
                            <>
                                <Route path="/:survey" element={<Home />} />
                                <Route
                                    path="/:survey/region"
                                    element={<Region />}
                                />
                                {isPrelimWithEffectiveDate && (
                                    <>
                                        <Route
                                            path="/:survey/country"
                                            element={<Country />}
                                        />
                                        <Route
                                            path="/:survey/practice"
                                            element={<Practice />}
                                        />
                                        <Route
                                            path="/:survey/historical"
                                            element={<Historical />}
                                        />
                                    </>
                                )}
                            </>
                        ) : null
                    ) : (
                        <>
                            <Route path="/:survey" element={<Home />} />
                            <Route
                                path="/:survey/region"
                                element={<Region />}
                            />
                            <Route
                                path="/:survey/country"
                                element={<Country />}
                            />
                            <Route
                                path="/:survey/practice"
                                element={<Practice />}
                            />
                            <Route
                                path="/:survey/participants"
                                element={<Participants />}
                            />
                            <Route
                                path="/:survey/historical"
                                element={<Historical />}
                            />
                            <Route
                                path="/:survey/definitions"
                                element={<Definitions />}
                            />
                        </>
                    )}

                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </div>
            <div className="footer-style printHidden">
                <tr>
                    <td>
                        {' '}
                        © {CURRENT_YEAR} Culpepper and Associates, Inc. All
                        Rights Reserved.{' '}
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                        <a href={CONTACT_US_LINK} className="footer-links">
                            Contact Us
                        </a>{' '}
                        |{' '}
                        <a href={PRIVACY_POLICY_LINK} className="footer-links">
                            Privacy Policy
                        </a>{' '}
                        |{' '}
                        <a
                            href={DATA_CONFIDENTIALITY_LINK}
                            className="footer-links"
                        >
                            Data Confidentiality and Protection
                        </a>{' '}
                        |{' '}
                        <a href={COOKIE_NOTICE_LINK} className="footer-links">
                            Cookie Notice
                        </a>
                    </td>
                </tr>
            </div>
        </div>
    )
}

function SiteRedirect() {
    window.location.replace(CULPEPPER_COME_LINK)
    return <div></div>
}

export default App
